/* eslint eqeqeq: "off", no-extend-native: "off", no-throw-literal: "off", no-use-before-define: "off" */

import React, { useRef } from 'react';
import '../css/styles.css';
import '../css/layout.css';
import { Scatter } from 'react-chartjs-2'

function Chart(props) {

    const chartRefSingle = useRef(null);
    const chartRefTop = useRef(null);
    const chartRefBottom = useRef(null);


    //TODO: Set this to take an argument for the ref, then download an image for the appropriate chart. Add text or a button to save.
    const downloadSingle = () => {
        if (chartRefSingle && chartRefSingle.current && chartRefSingle.current.chartInstance) {
            const base64image = chartRefSingle.current.chartInstance.toBase64Image();
            let filename = 'chart.png';
            var a = document.createElement('a');
            a.href = base64image;
            a.download = filename;
            a.click();
        }

    }

    const downloadTopChart = () => {
        if (chartRefTop && chartRefTop.current && chartRefTop.current.chartInstance) {
            const base64imageTop = chartRefTop.current.chartInstance.toBase64Image();

            let filename = 'top_chart.png';
            var a = document.createElement('a');
            a.href = base64imageTop
            a.download = filename;
            a.click();
        }
    };

    const downloadBottomChart = () => {
        if (chartRefBottom && chartRefBottom.current && chartRefBottom.current.chartInstance) {
            const base64imageBottom = chartRefBottom.current.chartInstance.toBase64Image();

            let filename = 'bottom_chart.png';
            var a = document.createElement('a');
            a.href = base64imageBottom
            a.download = filename;
            a.click();
        }
    };


    const datasets = (props.chartDataSingle || []).map((ds, i) => ({
        ...ds,
        label: ds.label || `Series ${i + 1}`,
        pointBackgroundColor: props.chartDataSingle[i].pointBackgroundColor || 'black',
        pointBorderColor: props.chartDataSingle[i].pointBackgroundColor || 'black',
        backgroundColor: props.chartDataSingle[i].pointBackgroundColor || 'black',
        borderColor: props.chartDataSingle[i].pointBackgroundColor || 'black',
    }));

    console.log("Chart props", props);
    return (
        <div style={{ height: "100%", width: "100%" }}>
            {props.chartType == "single" ?
                <>
                    <p onClick={() => { downloadSingle() }} style={{cursor:'pointer', fontSize: '.8rem', padding: 0, margin: 0, position: 'absolute', top: '5px', left: '5px' }}>Download plot</p>
                    
                    <Scatter
                        data={{
                            datasets: datasets
                        }}
                        options={{...props.chartOptionsSingle,
                            legend: {
                                display: true,
                                position: 'top',
                            },
                        }}
                        redraw={true}
                        ref={chartRefSingle
                        }
                    />
                </>
                :

                props.chartType == "double" ?
                    <>
                        <p onClick={downloadTopChart} style={{cursor:'pointer', fontSize: '.8rem', padding: 0, margin: 0, position: 'absolute', top: '5px', left: '5px' }}>Download top plot</p>
                        <p onClick={downloadBottomChart} style={{cursor:'pointer', fontSize: '.8rem', padding: 0, margin: 0, position: 'absolute', top: '5px', left: '150px' }}>Download bottom plot</p>

                        <div style={{ height: "50%" }}>
                            <Scatter
                                data={{
                                    datasets:
                                        props.chartDataTop
                                }}
                                options={
                                    props.chartOptionsTop}
                                redraw={true}
                                ref={chartRefTop}
                            />
                        </div>

                        
                        <div style={{ height: "50%" }}>
                            <Scatter
                                data={{
                                    datasets:
                                        props.chartDataBottom
                                }}
                                options={props.chartOptionsBottom}
                                redraw={true}
                                ref={chartRefBottom}
                            />
                        </div>
                    </>

                    : null

            }

        </div>
    )

}

export default Chart;